<div class="sidebar__header">
  <a class="sidebar__logo" [routerLink]="'/'" [attr.aria-label]="'MyDeals'">
    <crm-logo />
  </a>
  <span class="sidebar__brand" aria-hidden="true">MyDeals</span>

  <button
    type="button"
    class="sidebar__collapse"
    [attr.aria-label]="pinLabel() | translate"
    [title]="pinLabel() | translate"
    (click)="onTogglePin()"
  >
    <i class="pi pi-angle-double-left"></i>
  </button>
</div>

<nav class="sidebar__nav">
  @for (item of navItems(); track item.label) {
    @if (item.children) {
      <div class="sidebar__group" [class.is-open]="isGroupActive(item)">
        <a
          class="sidebar__item sidebar__item--group"
          [class.is-active]="isGroupActive(item)"
          [routerLink]="item.route"
          [attr.aria-expanded]="isExpanded() && isGroupActive(item)"
          [attr.aria-label]="item.label | translate"
          [title]="item.label | translate"
        >
          <i class="sidebar__icon pi" [class]="item.icon"></i>
          <span class="sidebar__label">{{ item.label | translate }}</span>
          <i class="sidebar__chevron pi pi-chevron-down" aria-hidden="true"></i>
        </a>

        <div class="sidebar__submenu" [attr.inert]="isExpanded() && isGroupActive(item) ? null : ''">
          <div class="sidebar__submenu-inner">
            @for (child of item.children; track child.route) {
              <a
                class="sidebar__subitem"
                routerLinkActive="is-active"
                [routerLink]="child.route"
                [title]="child.label | translate"
              >
                <span class="sidebar__bullet" aria-hidden="true"></span>
                <span class="sidebar__label">{{ child.label | translate }}</span>
              </a>
            }
          </div>
        </div>
      </div>
    } @else {
      <a
        class="sidebar__item"
        routerLinkActive="is-active"
        [routerLink]="item.route"
        [attr.aria-label]="item.label | translate"
        [title]="item.label | translate"
      >
        <i class="sidebar__icon pi" [class]="item.icon"></i>
        <span class="sidebar__label">{{ item.label | translate }}</span>
      </a>
    }
  }
</nav>

<div class="sidebar__footer">
  <button
    type="button"
    class="sidebar__user"
    [title]="fullName()"
    [attr.aria-label]="fullName()"
    aria-haspopup="true"
    (click)="userMenu.toggle($event)"
  >
    <crm-avatar class="sidebar__avatar" [src]="avatarUrl()" [name]="fullName()" [size]="28" />
    <div class="sidebar__user-info">
      <span class="sidebar__user-name">{{ fullName() }}</span>
      @if (roleLabel(); as role) {
        <span class="sidebar__user-role">{{ role | translate }}</span>
      }
    </div>
  </button>
</div>

<p-menu #userMenu [model]="menuItems()" [popup]="true" appendTo="body" />
